import { Platform } from 'react-native';

/**
 * Dynamically load a script from a URL.  This is only available on web.
 */
export function dynamicallyLoadScript(url: string): Promise<void> {
    if (Platform.OS !== 'web') {
        throw new Error('loadScript is only available on web');
    }

    return new Promise((resolve, reject) => {
        try {
            const scripts = document.querySelectorAll('script');
            for (let i = 0; i < scripts.length; i++) {
                if (scripts[i].src === url) {
                    const script = scripts[i];
                    if (!script.onload) {
                        resolve();
                    } else {
                        // script not loaded so wait up to 10 seconds
                        let secs = 0;
                        const thisInterval = setInterval(function () {
                            secs++;
                            if (!script.onload) {
                                clearInterval(thisInterval);
                                resolve();
                            } else if (secs == 10) {
                                clearInterval(thisInterval);
                                console.error('could not load ' + url);
                            }
                        }, 1000);
                    }
                    return;
                }
            }
            const createdScript = document.createElement('script');
            createdScript.type = 'text/javascript';
            document.getElementsByTagName('head')[0].appendChild(createdScript);
            createdScript.onload = function () {
                createdScript.onload = null;
                resolve();
            };
            createdScript.src = url;
        } catch (error) {
            reject(error);
        }
    });
}
